import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import env from '@/env';

export const updateDefaultConnection = async ({
  defaultConnectionId,
}: {
  defaultConnectionId: string;
}): Promise<Response> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/users/me/settings/default-connection`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ defaultConnectionId }),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  return fetchResponse;
};
